export default __webpack_public_path__ + "static/media/POTImg.0f6a842a.jpg";